<div class="flex flex-col h-full pl-8">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-[32px] font-bold mt-6">
        {{ 'update-settings.title' | translate }}
      </h1>
      <p class="mb-[30px]">{{ 'update-settings.subtitle' | translate }}</p>
    </div>
    <div class="flex items-center">
      <rk-api-error-alert></rk-api-error-alert>
      <rk-button
        [text]="'update-settings.save' | translate"
        (buttonClick)="onSaveSettings()"
        [isLoading]="isLoading$ | async"
      ></rk-button>
    </div>
  </div>

  <div class="bg-white rounded settings-subcontainer flex flex-col">
    <!-- sticky navigation -->
    <div class="sticky top-0 bg-white z-10 p-6 pb-0">
      <rk-app-settings-nav></rk-app-settings-nav>
    </div>

    <!-- scrollable Content -->
    <div class="flex-1 overflow-y-auto">
      <div class="p-6">
        <!-- app name -->
        <rk-app-name-section
          id="section-name"
          [appName]="appName.value"
          (appNameChange)="appName.setValue($event)"
        >
        </rk-app-name-section>

        <div class="my-8"><rk-setting-divider></rk-setting-divider></div>

        <!-- images -->
        <div id="section-logos">
          <h2 class="text-xl font-bold mb-3">
            {{ 'assets.update-image-title' | translate }}
          </h2>

          <div
            class="update-asset-group flex justify-between gap-8"
            [style.flex-direction]="flexDirection$ | async"
          >
            <!-- logos section -->
            <div class="flex-1">
              <rk-logo-assets-section
                (crop)="openCropper($event)"
                (replace)="replaceAsset($event)"
                [assetWidth]="assetWidth"
              >
              </rk-logo-assets-section>
            </div>

            <!-- splashscreen section -->
            <div [style.flex]="rightColumnFlexProportion">
              <rk-splashscreen-assets-section
                (crop)="openCropper($event)"
                (replace)="replaceAsset($event)"
                [assetWidth]="assetWidth"
              >
              </rk-splashscreen-assets-section>
            </div>
          </div>
        </div>

        <div class="my-8"><rk-setting-divider></rk-setting-divider></div>

        <!-- monetization -->
        <div id="section-monetization">
          <rk-monetization-section></rk-monetization-section>
        </div>

        <!-- privacy -->
        <div class="my-8"><rk-setting-divider></rk-setting-divider></div>
        <div id="section-privacy">
          <rk-privacy-section></rk-privacy-section>
        </div>
      </div>
    </div>
  </div>
</div>
